import { useContext } from "react";
import { CheckoutContext } from "../contexts/CheckoutContext";

const useTrackingPixels = () => {
  const { offer } = useContext(CheckoutContext);

  return (
    offer?.tracking_pixels || {
      facebook_pixels: [],
      google_ads_pixels: [],
      fbBoletoConversionValue: 0,
      fbBoletoPurchaseTrigger: false,
      fbPixConversionValue: 0,
      fbPixPurchaseTrigger: false,
      googleAnalyticsTrackingId: null,
      kwaiBoletoConversionValue: 0,
      kwaiBoletoPurchaseTrigger: false,
      kwaiPixConversionValue: 0,
      kwaiPixPurchaseTrigger: false,
      pixelEventId: "",
      pixel_domains: [],
      taboola_pixels: [],
      kwai_pixels: [],
      outbrain_pixels: [],
      tiktok_pixels: [],
      tiktokBoletoConversionValue: 0,
      tiktokBoletoPurchaseTrigger: false,
      tiktokPixConversionValue: 0,
      tiktokPixPurchaseTrigger: false,
    }
  );
};

export { useTrackingPixels };
